// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__JNfeI","colCheckbox":"styles_colCheckbox__2Z6Ih"};